import Image, { ImageProps } from 'next/image';
import * as S from './styles.ts';
import UniversalLink from '@template/components/UniversalLink';

export type TPost = {
  type: string;
  title: string;
  author: string;
  authorDisplayPicture?: ImageProps['src'];
  url: string;
  date: string;
  minutesToRead?: number;
  color: 'primary' | 'secondary' | 'default';
};

const PostCard = ({
  type,
  title,
  author,
  authorDisplayPicture,
  url,
  date,
  minutesToRead,
  color,
}: TPost) => {
  return (
    <UniversalLink href={url}>
      <S.PostCardContainer>
        <S.PostCardHeader>
          <S.PostCardPill $color={color || 'primary'}>
            <p>{type}</p>
          </S.PostCardPill>
          <p>{title}</p>
        </S.PostCardHeader>
        <S.PostCardFooter>
          {authorDisplayPicture && (
            <Image
              src={authorDisplayPicture}
              alt={author}
              height={30}
              width={30}
            />
          )}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <p>{author}</p>
            <p>{date}</p>
          </div>
          {minutesToRead && (
            <>
              {' '}
              <p>.</p>
              <p> {minutesToRead} min read</p>
            </>
          )}
        </S.PostCardFooter>
      </S.PostCardContainer>
    </UniversalLink>
  );
};

export default PostCard;
